/* IMPERIAL-STITCH-WATCHES-PLP — CLEAN LAUNCH BUNDLE — 04 OCT 2026
   Legacy main-card mutation passes removed. Product title/spec/price/status are
   server-rendered in Liquid. */

/* ===== assets/imperial-stitch-watches-plp-v1.js ===== */
/* IMPERIAL-STITCH-WATCHES-PLP-V2-UX
   Progressive enhancement only. Shopify filtering/sorting/product data remains authoritative.
*/
(function(){
  const ROOT='.page-collection[data-template-suffix="luxury-watches"]';

  function inScope(){
    return document.body && document.body.matches(ROOT);
  }

  function setBrandCopy(){
    const section=document.querySelector('.it-watch-brand-nav');
    if(!section) return;
    const kicker=section.querySelector('.it-watch-brand-nav__kicker');
    const heading=section.querySelector('h2');
    const all=section.querySelector('.it-watch-brand-nav__all');
    if(kicker && kicker.textContent!=='SHOP BY WATCH HOUSE') kicker.textContent='SHOP BY WATCH HOUSE';
    if(heading && heading.textContent!=='Explore leading watch brands') heading.textContent='Explore leading watch brands';
    if(all && all.textContent!=='View all brands →') all.textContent='View all brands →';
    section.querySelectorAll('.it-watch-brand-nav__name').forEach(function(name){
      const cleaned=(name.textContent||'').replace(/\s+watches$/i,'').trim();
      if(cleaned && name.textContent!==cleaned) name.textContent=cleaned;
    });
  }

  function activeFilterCount(aside){
    if(!aside) return 0;
    return aside.querySelectorAll('input[type="checkbox"]:checked').length +
      aside.querySelectorAll('input[type="radio"]:checked').length +
      Array.from(aside.querySelectorAll('input[type="number"]')).filter(function(i){
        return i.value && i.defaultValue && i.value!==i.defaultValue;
      }).length;
  }

  function addRefinementHeader(){
    const aside=document.querySelector('#main-collection-filters');
    if(!aside) return;
    let head=aside.querySelector('.it-stitch-refinement-head');
    if(!head){
      head=document.createElement('div');
      head.className='it-stitch-refinement-head';
      head.innerHTML=
        '<div class="it-stitch-refinement-head__row">'+
          '<h2 class="it-stitch-refinement-title">Refinement</h2>'+
          '<span class="it-stitch-refinement-label">KENSINGTON<br>W8</span>'+
        '</div>'+
        '<div class="it-stitch-refinement-meta"><span class="it-stitch-refinement-count">0 active</span><span>Filter & compare</span></div>';
      aside.insertBefore(head,aside.firstChild);
    }
    const count=head.querySelector('.it-stitch-refinement-count');
    if(count){
      const n=activeFilterCount(aside);
      const next=n ? n+' active' : 'All watches';
      if(count.textContent!==next) count.textContent=next;
    }
  }

  /* IMPERIAL-STITCH-WATCHES-PLP-V3-FILTERS */
  function reorderFilterGroups(){
    const wrapper=document.querySelector('#main-collection-filters #FacetsWrapperDesktop');
    if(!wrapper || wrapper.dataset.itStitchOrdered==='1') return;
    const details=Array.from(wrapper.querySelectorAll(':scope > details.facets__disclosure-vertical'));
    if(details.length<2) return;
    wrapper.dataset.itStitchOrdered='1';

    const priority=function(label){
      const t=label.toLowerCase();
      if(t.includes('price')) return 10;
      if(t.includes('brand') || t.includes('watch house') || t.includes('vendor')) return 20;
      if(t.includes('model')) return 30;
      if(t.includes('case') || t.includes('diameter') || t.includes('size')) return 40;
      if(t.includes('dial') || t.includes('color') || t.includes('colour')) return 50;
      if(t.includes('material') || t.includes('metal')) return 60;
      if(t.includes('condition') || t.includes('provenance')) return 70;
      if(t.includes('availability') || t.includes('stock')) return 80;
      return 100;
    };

    details.sort(function(a,b){
      const al=(a.querySelector('summary')?.textContent||'').trim();
      const bl=(b.querySelector('summary')?.textContent||'').trim();
      return priority(al)-priority(bl);
    }).forEach(function(d){wrapper.appendChild(d);});

    details.forEach(function(d,index){
      const hasActive=!!d.querySelector('input:checked') ||
        Array.from(d.querySelectorAll('input[type="number"]')).some(function(i){
          return i.value && i.defaultValue && i.value!==i.defaultValue;
        });
      if(hasActive || index<4) d.setAttribute('open','');
      else d.removeAttribute('open');
    });
  }


  function classifyAndLabelFilters(){
    const wrapper=document.querySelector('#main-collection-filters #FacetsWrapperDesktop');
    if(!wrapper) return;
    const details=Array.from(wrapper.querySelectorAll(':scope > details.facets__disclosure-vertical'));

    details.forEach(function(d){
      const summary=d.querySelector('summary');
      const span=summary && summary.querySelector('span');
      const raw=(span?.childNodes?.[0]?.textContent || span?.textContent || '').trim();
      const t=raw.toLowerCase();

      const wanted=t.includes('price')?'it-stitch-filter--price':((t.includes('brand')||t.includes('vendor')||t.includes('watch house'))?'it-stitch-filter--brand':((t.includes('dial')||t.includes('color')||t.includes('colour'))?'it-stitch-filter--dial':((t.includes('availability')||t.includes('stock'))?'it-stitch-filter--availability':null)));
      ['it-stitch-filter--price','it-stitch-filter--brand','it-stitch-filter--dial','it-stitch-filter--availability'].forEach(function(c){const enabled=c===wanted;if(d.classList.contains(c)!==enabled)d.classList.toggle(c,enabled);});

      if(t.includes('price')){
        
        if(span && span.firstChild && span.firstChild.textContent!=='Price Spectrum (£)') span.firstChild.textContent='Price Spectrum (£)';
      } else if(t.includes('brand') || t.includes('vendor') || t.includes('watch house')){
        
        if(span && span.firstChild && span.firstChild.textContent!=='Watch House') span.firstChild.textContent='Watch House';
      } else if(t.includes('dial') || t.includes('color') || t.includes('colour')){
        
        if(span && span.firstChild && span.firstChild.textContent!=='Dial Colour') span.firstChild.textContent='Dial Colour';
      } else if(t.includes('availability') || t.includes('stock')){
        
        if(span && span.firstChild && span.firstChild.textContent!=='Availability') span.firstChild.textContent='Availability';
      }
    });
  }


  function orderBrandValues(){
    const detail=document.querySelector('#main-collection-filters .it-stitch-filter--brand');
    if(!detail || detail.dataset.itBrandOrdered==='1') return;
    const list=detail.querySelector('.facets__list--vertical');
    if(!list) return;
    const order=['rolex','audemars piguet','patek philippe','cartier','omega','richard mille','tudor','tag heuer','breitling','iwc','vacheron constantin','hublot','bvlgari','panerai','jaeger lecoultre','swatch'];
    const rank=function(text){
      const t=text.toLowerCase().replace(/[-–—]/g,' ').replace(/\s+/g,' ').trim();
      const i=order.findIndex(function(name){return t.includes(name);});
      return i<0 ? 999 : i;
    };
    const items=Array.from(list.querySelectorAll(':scope > li.facets__item'));
    items.sort(function(a,b){
      return rank(a.textContent||'')-rank(b.textContent||'');
    }).forEach(function(item){list.appendChild(item);});
    detail.dataset.itBrandOrdered='1';
  }

  function compactBrandFilter(){
    const detail=document.querySelector('#main-collection-filters .it-stitch-filter--brand');
    if(!detail) return;
    const list=detail.querySelector('.facets__list--vertical');
    if(!list) return;

    const items=Array.from(list.querySelectorAll(':scope > li.facets__item'));
    items.forEach(function(item,index){
      if(index>=7) item.classList.add('it-stitch-brand-extra');
      else item.classList.remove('it-stitch-brand-extra');
    });

    if(items.length>7 && !detail.querySelector('.it-stitch-brand-toggle')){
      const button=document.createElement('button');
      button.type='button';
      button.className='it-stitch-brand-toggle';
      button.textContent='Show all watch houses';
      button.addEventListener('click',function(){
        const expanded=detail.classList.toggle('is-expanded');
        button.textContent=expanded ? 'Show fewer watch houses' : 'Show all watch houses';
      });
      const display=detail.querySelector('.facets__display-vertical');
      if(display) display.appendChild(button);
    }
  }


  function addPriceSpectrumGraph(){
    const detail=document.querySelector('#main-collection-filters .it-stitch-filter--price');
    if(!detail || detail.querySelector('.it-stitch-price-graph')) return;
    const priceRange=detail.querySelector('price-range');
    if(!priceRange) return;
    const slider=priceRange.querySelector('.range-slider');
    const graph=document.createElement('div');
    graph.className='it-stitch-price-graph';
    graph.setAttribute('aria-hidden','true');
    graph.innerHTML='<span></span><span></span><span></span><span></span><span></span><span></span><span></span>';
    if(slider) priceRange.insertBefore(graph,slider);
    else priceRange.appendChild(graph);
  }

  function addSourcingCard(){
    const aside=document.querySelector('#main-collection-filters');
    if(!aside || aside.querySelector('.it-stitch-sourcing')) return;
    const card=document.createElement('div');
    card.className='it-stitch-sourcing';
    card.innerHTML=
      '<span class="it-stitch-sourcing__eyebrow">Specialist sourcing</span>'+
      '<p>Looking for a particular watch not shown online? Speak directly with our Kensington team.</p>'+
      '<a href="/pages/contact">Contact our team →</a>';
    aside.appendChild(card);
  }

  function addTradeCard(){
    const grid=document.querySelector('#product-grid');
    if(!grid || grid.querySelector('.it-stitch-trade-card')) return;
    const items=grid.querySelectorAll(':scope > li.grid__item[data-imperial-list-item]');
    if(items.length<4) return;
    const li=document.createElement('li');
    li.className='grid__item it-stitch-trade-card';
    li.setAttribute('aria-label','Sell or part-exchange your watch');
    li.innerHTML=
      '<div class="it-stitch-trade-card__inner">'+
        '<div><span class="it-stitch-trade-card__eyebrow">SELL · PART-EXCHANGE</span>'+
        '<h3>Sell or Part-Exchange Your Watch</h3>'+
        '<p>Speak directly with the Imperial Time team about selling or part-exchanging a luxury watch. Start online, then arrange inspection where required.</p></div>'+
        '<a href="/pages/sell-luxury-watches-london">Request a valuation →</a>'+
      '</div>';
    const openingColumns=window.matchMedia('(max-width: 989px)').matches ? 2 : 3;
    const openingAnchor=items[Math.min(openingColumns - 1, items.length - 1)];
    if(openingAnchor) openingAnchor.insertAdjacentElement('afterend',li);
  }


  function polishToolbar(){
    const count=document.querySelector('#ProductCountDesktop');
    if(count){
      const text=(count.textContent||'').trim();
      const match=text.match(/[\d,]+/);
      if(match && count.textContent!==match[0]+' WATCHES') count.textContent=match[0]+' WATCHES';
    }
  }

  function polishSelected(){
    document.querySelectorAll('.imperial-selected-watches .card__heading a, .imperial-selected-watches .card__heading').forEach(function(el){
      el.setAttribute('title',(el.textContent||'').trim());
    });
  }

  function run(){
    if(!inScope()) return;
    setBrandCopy();
    addRefinementHeader();
    reorderFilterGroups();
    classifyAndLabelFilters();
    orderBrandValues();
    compactBrandFilter();
    addPriceSpectrumGraph();
    addSourcingCard();
    addTradeCard();
    polishToolbar();
    polishSelected();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',run,{once:true});
  } else {
    run();
  }

  let timer;
  const observer=new MutationObserver(function(mutations){
    const relevant=mutations.some(function(m){
      const t=m.target;
      return t && (
        t.id==='ProductGridContainer' ||
        t.id==='main-collection-filters' ||
        (t.closest && (t.closest('#ProductGridContainer') || t.closest('#main-collection-filters')))
      );
    });
    if(relevant){
      clearTimeout(timer);
      timer=setTimeout(run,60);
    }
  });
  observer.observe(document.documentElement,{subtree:true,childList:true});

  document.addEventListener('change',function(e){
    if(inScope() && e.target && e.target.closest && e.target.closest('#main-collection-filters')){
      setTimeout(addRefinementHeader,30);
    }
  });
  document.addEventListener('shopify:section:load',function(){setTimeout(run,30)});
})();

/* ===== assets/imperial-stitch-watches-plp-v10.js ===== */
/* IMPERIAL-STITCH-WATCHES-PLP-V14-GRID-EDITORIAL-OMEGA-CLOSURE */
(function(){
  function inScope(){
    return location.pathname.indexOf('/collections/watches')===0;
  }

  function productItems(grid){
    return Array.from(grid.querySelectorAll(':scope > li.grid__item[data-imperial-list-item]'));
  }

  function balanceTradeCard(){
    const grid=document.querySelector('#product-grid');
    if(!grid) return;

    let trade=grid.querySelector(':scope > .it-stitch-trade-card');
    const items=productItems(grid);

    if(items.length<4){
      if(trade) trade.remove();
      return;
    }
    if(!trade) return;

    /* Put the editorial interruption immediately after the first complete product row
       at the active breakpoint. Desktop is three columns; tablet/mobile is two.
       This prevents a stranded product beside the full-width editorial card. */
    const isNarrow=window.matchMedia('(max-width: 989px)').matches;
    const rowColumns=isNarrow ? 2 : 3;
    const anchor=items[Math.min(rowColumns - 1, items.length - 1)];
    if(anchor && anchor.nextElementSibling!==trade){
      anchor.insertAdjacentElement('afterend',trade);
    }

    trade.classList.remove(
      'it-stitch-trade-card--span-1',
      'it-stitch-trade-card--span-2',
      'it-stitch-trade-card--span-3'
    );

    if(isNarrow){
      trade.classList.add('it-stitch-trade-card--span-3');
      return;
    }

    /* Choose the editorial width so products + editorial grid slots end on a complete
       three-column row. This prevents a stranded one-card tail. */
    const remainder=items.length % 3;
    const span=remainder===1 ? 2 : remainder===2 ? 1 : 3;
    trade.classList.add('it-stitch-trade-card--span-'+span);
  }

  function centreOmega(){
    const omega=document.querySelector('.it-watch-brand-nav__card[href*="/collections/omega"] .it-watch-brand-nav__media img');
    if(!omega) return;
    omega.style.objectPosition='50% 50%';
    omega.style.objectFit='contain';
  }

  function run(){
    if(!inScope()) return;
    balanceTradeCard();
    centreOmega();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){setTimeout(run,80);},{once:true});
  } else {
    setTimeout(run,80);
  }

  let timer;
  const observer=new MutationObserver(function(records){
    const relevant=records.some(function(r){
      const t=r.target;
      return t && t.closest && (
        t.closest('#ProductGridContainer') ||
        t.closest('.it-watch-brand-nav')
      );
    });
    if(relevant){
      clearTimeout(timer);
      timer=setTimeout(run,120);
    }
  });
  observer.observe(document.documentElement,{subtree:true,childList:true});

  window.addEventListener('resize',function(){
    clearTimeout(timer);
    timer=setTimeout(run,120);
  });

  document.addEventListener('shopify:section:load',function(){setTimeout(run,100);});
})();

/* ===== assets/imperial-stitch-watches-plp-v12.js ===== */
/* IMPERIAL-STITCH-WATCHES-PLP-V16-SELECTED-TOP-FILTER-UNIFICATION */
(function(){
  function clean(v){return String(v||'').replace(/\s+/g,' ').trim();}
  function rawTitle(card){
    const h=card.querySelector('.card__heading a');
    return h?clean(h.getAttribute('aria-label')||h.getAttribute('title')||h.textContent):'';
  }
  function findRef(raw){
    const tokens=clean(raw).split(' ');
    return tokens.find(function(t){
      const x=t.replace(/[“”‘’'(),]/g,'');
      return (x.match(/\d/g)||[]).length>=4 && x.length>=5;
    })||'';
  }

  function assureIntro(){
    const wrap=document.querySelector('[id*="rich_text"] .rich-text__wrapper');
    if(!wrap || wrap.querySelector('.it-watch-intro-assurance')) return;
    const box=document.createElement('div');
    box.className='it-watch-intro-assurance';
    box.innerHTML=
      '<div class="it-watch-intro-assurance__item">'+
        '<span class="it-watch-intro-assurance__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 10.5 12 4l8 6.5"/><path d="M6.5 9.5V20h11V9.5"/><path d="M9.5 20v-6h5v6"/></svg></span>'+
        '<span>Kensington showroom</span>'+
      '</div>'+
      '<div class="it-watch-intro-assurance__item">'+
        '<span class="it-watch-intro-assurance__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 6.5h11v9H3z"/><path d="M14 9h3.8l3.2 3.3v3.2h-7"/><circle cx="7" cy="17.5" r="1.7"/><circle cx="18" cy="17.5" r="1.7"/></svg></span>'+
        '<span>Insured tracked delivery</span>'+
      '</div>';
    wrap.appendChild(box);
  }

  function refineSelected(){
    document.querySelectorAll('.imperial-selected-watches .grid__item').forEach(function(li){
      const card=li.querySelector('.card');
      if(!card) return;
      const raw=rawTitle(card);
      const ref=card.querySelector('.it-watch-card-refrow__ref');
      const parsed=findRef(raw).replace(/[“”‘’'(),]/g,'');
      if(ref && parsed && ref.textContent!=='REF. '+parsed) ref.textContent='REF. '+parsed;
      card.querySelectorAll('.product__vendor').forEach(function(el){el.style.display='none';});
    });
  }

  function classifyFilters(){
    document.querySelectorAll('#main-collection-filters .facets__disclosure-vertical').forEach(function(d){
      const s=clean(d.querySelector('summary')?.textContent||'').toLowerCase();
      d.classList.remove('it-filter-price','it-filter-brand','it-filter-case-size','it-filter-condition','it-filter-availability','it-filter-dial');
      if(s.includes('price')) d.classList.add('it-filter-price');
      if(s.includes('brand')||s.includes('watch house')) d.classList.add('it-filter-brand');
      if(s.includes('case') && (s.includes('diameter')||s.includes('size'))) d.classList.add('it-filter-case-size');
      if(s.includes('condition')||s.includes('provenance')) d.classList.add('it-filter-condition');
      if(s.includes('availability')) d.classList.add('it-filter-availability');
      if(s.includes('dial')) d.classList.add('it-filter-dial');
    });
  }

  function toolbarActiveFilters(){
    const bar=document.querySelector('.wbsortbar');
    if(!bar) return;
    let holder=bar.querySelector('.it-stitch-toolbar-active');
    if(!holder){
      holder=document.createElement('div');
      holder.className='it-stitch-toolbar-active';
      const form=bar.querySelector('.facets-vertical-sort');
      if(form) form.insertAdjacentElement('afterend',holder);
      else bar.appendChild(holder);
    }
    const source=document.querySelector('#main-collection-filters .active-facets');
    const buttons=source ? Array.from(source.querySelectorAll('a.active-facets__button')) : [];
    const reset=source ? source.querySelector('a.active-facets__button-remove, a[href*="/collections/watches"]:not(.active-facets__button)') : null;

    const seen=new Set();
    const html=[];
    buttons.forEach(function(a){
      const label=clean(a.textContent).replace(/×/g,'').trim();
      const href=a.getAttribute('href');
      if(!label||!href||seen.has(label)) return;
      seen.add(label);
      html.push('<a href="'+href.replace(/"/g,'&quot;')+'">'+label+' <span aria-hidden="true">×</span></a>');
    });
    if(reset && html.length){
      const href=reset.getAttribute('href')||'/collections/watches';
      html.push('<a class="it-stitch-toolbar-active__reset" href="'+href.replace(/"/g,'&quot;')+'">Reset filters</a>');
    }
    const nextHtml=html.join('');
    if(holder.innerHTML!==nextHtml) holder.innerHTML=nextHtml;
    holder.style.display=html.length?'flex':'none';
  }

  function polishCount(){
    const node=document.querySelector('#ProductCountDesktop');
    if(!node) return;
    const t=clean(node.textContent);
    const m=t.match(/(\d[\d,]*)/);
    if(m && node.textContent!==m[1]+' curated lots') node.textContent=m[1]+' curated lots';
  }

  function run(){
    if(!location.pathname.includes('/collections/watches')) return;
    assureIntro();
    refineSelected();
    classifyFilters();
    toolbarActiveFilters();
    polishCount();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){setTimeout(run,60);},{once:true});
  else setTimeout(run,60);

  let timer;
  const obs=new MutationObserver(function(records){
    if(records.some(function(r){
      const t=r.target;
      return t&&t.closest&&(t.closest('#ProductGridContainer')||t.closest('#main-collection-filters')||t.closest('.wbsortbar')||t.closest('.imperial-selected-watches'));
    })){
      clearTimeout(timer); timer=setTimeout(run,100);
    }
  });
  obs.observe(document.documentElement,{subtree:true,childList:true});
  document.addEventListener('shopify:section:load',function(){setTimeout(run,80);});
})();

/* ===== assets/imperial-stitch-watches-plp-v13.js ===== */
/* IMPERIAL-STITCH-WATCHES-PLP-V17-TOP-CONTROLS-SELECTED-CARD-CLOSURE */
(function(){
  const KEY='imperial_time_watch_wishlist_v1';
  function clean(v){return String(v||'').replace(/\s+/g,' ').trim();}
  function titleCase(v){return clean(v).toLowerCase().replace(/\b\w/g,function(c){return c.toUpperCase();});}
  function saved(){try{const x=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(x)?x:[];}catch(_){return [];}}
  function saveList(x){try{localStorage.setItem(KEY,JSON.stringify(x));}catch(_){}}

  function refFrom(raw,sku){
    const source=clean(raw)+' '+clean(sku);
    const alpha=(source.match(/\b[A-Z]{2,}\d{3,}[A-Z0-9/-]*\b/)||[])[0];
    const num=(source.match(/\b\d{4,6}(?:[-/][A-Z0-9]+)*\b/)||[])[0];
    if(num) return num;
    if(alpha) return alpha;
    const parts=clean(sku).split(/[-_\s]+/);
    const likely=parts.find(function(p){return (p.match(/\d/g)||[]).length>=4;});
    return likely||clean(sku);
  }

  function modelTitle(vendor,raw){
    const low=raw.toLowerCase();
    const maps={
      'rolex':['cosmograph daytona','gmt-master ii','oyster perpetual','submariner date','submariner','datejust','day-date','yacht-master','sky-dweller','sea-dweller','explorer ii','explorer'],
      'patek philippe':['twenty~4','twenty-4','nautilus','aquanaut','calatrava'],
      'audemars piguet':['royal oak offshore','royal oak'],
      'cartier':['santos de cartier','santos','tank française','tank francaise','tank','ballon bleu','panthère','panthere']
    };
    const hit=(maps[vendor.toLowerCase()]||[]).find(function(m){return low.includes(m);});
    if(!hit) return clean(raw.replace(new RegExp('^'+vendor+'\\s*','i'),'').split(/\b(?:19|20)\d{2}\b/)[0]).split(/\s+/).slice(0,5).join(' ');
    let display=hit;
    if(hit==='gmt-master ii') display='GMT-Master II';
    else if(hit==='twenty~4') display='Twenty~4';
    else if(hit==='twenty-4') display='Twenty-4';
    else display=titleCase(hit);

    if(vendor.toLowerCase()==='rolex'){
      const size=(raw.match(/\b(31|34|36|37|39|40|41|42|43|44)\s*mm\b/i)||[])[1];
      if(size) display+=' '+size;
      else if(/oyster perpetual/i.test(hit)&&/\b134300\b/.test(raw)) display+=' 41';
    }
    return display;
  }

  function specLine(raw){
    const bits=[];
    const dial=(raw.match(/(?:Tahitian Mother-of-Pearl|Mother-of-Pearl|Champagne|Green|Blue|Black|Silver|White|Pink|Turquoise|Diamond)[^,]*?\bDial\b/i)||[])[0];
    if(dial) bits.push(clean(dial).replace(/\b(?:Rolex|Patek Philippe|Audemars Piguet|Cartier)\b/ig,'').trim());

    const bracelet=(raw.match(/\b(?:Oysterflex|Oyster|Jubilee|President|Presidential|Leather|Rubber)\s+(?:Bracelet|Strap)\b/i)||[])[0];
    if(bracelet) bits.push(clean(bracelet));

    const mm=(raw.match(/\b\d{2}(?:\.\d)?\s*mm\b/i)||[])[0];
    if(mm) bits.push(clean(mm).replace(/\s+/g,''));

    if(!bits.length && /diamond baguette/i.test(raw)) bits.push('Diamond Baguette');
    if(!bits.length && /diamond/i.test(raw)) bits.push('Diamond specification');
    return bits.slice(0,3).join(' · ');
  }

  function polishSelected(){
    document.querySelectorAll('.it-selected-watch').forEach(function(li){
      const raw=li.getAttribute('data-it-raw-title')||'';
      const vendor=li.getAttribute('data-it-vendor')||'';
      const sku=li.getAttribute('data-it-sku')||'';
      const title=li.querySelector('[data-it-feature-title]');
      const spec=li.querySelector('[data-it-feature-spec]');
      const ref=li.querySelector('[data-it-feature-ref]');
      if(title){const next=modelTitle(vendor,raw);if(title.textContent!==next)title.textContent=next;}
      if(spec){const next=specLine(raw);if(spec.textContent!==next)spec.textContent=next;}
      if(ref){const next='REF. '+refFrom(raw,sku);if(ref.textContent!==next)ref.textContent=next;}

      const heart=li.querySelector('.it-feature-watch-card__heart');
      if(heart){
        const href=heart.getAttribute('data-it-save')||'';
        const active=saved().includes(href);
        heart.textContent=active?'♥':'♡';
        heart.setAttribute('aria-pressed',active?'true':'false');
        if(!heart.dataset.bound){
          heart.dataset.bound='1';
          heart.addEventListener('click',function(){
            let list=saved();
            list=list.includes(href)?list.filter(function(x){return x!==href;}):list.concat(href);
            saveList(list);
            heart.textContent=list.includes(href)?'♥':'♡';
            heart.setAttribute('aria-pressed',list.includes(href)?'true':'false');
          });
        }
      }
    });
  }

  function bindTopSort(){
    const select=document.getElementById('ITWatchTopSort');
    if(!select || select.dataset.bound) return;
    select.dataset.bound='1';
    select.addEventListener('change',function(){
      const url=new URL(location.href);
      url.searchParams.set('sort_by',select.value);
      location.href=url.toString();
    });
  }

  function bindViewToggles(){
    document.querySelectorAll('.it-watch-view-toggle__button').forEach(function(btn){
      if(btn.dataset.bound) return;
      btn.dataset.bound='1';
      btn.addEventListener('click',function(){
        const view=btn.getAttribute('data-it-view');
        const originals=Array.from(document.querySelectorAll('.wbsortbar .wblistgridbtn'));
        if(originals.length){
          const target=view==='grid'?originals[0]:originals[originals.length-1];
          if(target) target.click();
        }
        document.querySelectorAll('.it-watch-view-toggle__button').forEach(function(b){b.classList.toggle('is-active',b===btn);});
      });
    });
  }

  function run(){
    if(!location.pathname.includes('/collections/watches')) return;
    polishSelected();
    bindTopSort();
    bindViewToggles();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){setTimeout(run,70);},{once:true});
  else setTimeout(run,70);

  document.addEventListener('shopify:section:load',function(){setTimeout(run,80);});
})();

/* ===== assets/imperial-stitch-watches-plp-v23.js ===== */
(()=>{
  const ROOT='.page-collection[data-template-suffix="luxury-watches"]';
  const selector=ROOT+' #main-collection-filters price-range .number-slider input[type="number"]';

  function wholePounds(root=document){
    root.querySelectorAll(selector).forEach(input=>{
      const value=String(input.value||'').trim();
      if(/^\d+\.00$/.test(value)) input.value=value.slice(0,-3);
      const placeholder=String(input.placeholder||'').trim();
      if(/^\d+\.00$/.test(placeholder)) input.placeholder=placeholder.slice(0,-3);
      input.step='1';
    });
  }

  function init(){
    wholePounds();
    const filters=document.querySelector(ROOT+' #main-collection-filters');
    if(!filters) return;
    const observer=new MutationObserver(()=>wholePounds());
    observer.observe(filters,{childList:true,subtree:true});
    filters.addEventListener('change',()=>requestAnimationFrame(()=>wholePounds()),true);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

/* ===== assets/imperial-stitch-watches-plp-v24.js ===== */
(()=>{
  const selector='#main-collection-filters price-range .number-slider input[type="number"]';

  const normalise=input=>{
    const n=Number.parseFloat(String(input.value||'').replace(/,/g,''));
    if(Number.isFinite(n)){
      const whole=String(Math.round(n));
      if(input.value!==whole) input.value=whole;
      input.setAttribute('value',whole);
    }
    const p=Number.parseFloat(String(input.placeholder||'').replace(/,/g,''));
    if(Number.isFinite(p)) input.placeholder=String(Math.round(p));
    const max=Number.parseFloat(String(input.max||'').replace(/,/g,''));
    if(Number.isFinite(max)) input.max=String(Math.round(max));
    input.step='1';
  };

  const normaliseAll=()=>{
    document.querySelectorAll(selector).forEach(normalise);
  };

  const init=()=>{
    normaliseAll();
    requestAnimationFrame(normaliseAll);
    setTimeout(normaliseAll,100);
    setTimeout(normaliseAll,500);
    const filters=document.querySelector('#main-collection-filters');
    if(filters){
      new MutationObserver(()=>requestAnimationFrame(normaliseAll))
        .observe(filters,{childList:true,subtree:true});
      ['focusin','input','change'].forEach(evt=>{
        filters.addEventListener(evt,e=>{
          if(e.target&&e.target.matches(selector)) normalise(e.target);
        },true);
      });
    }
  };

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

/* ===== assets/imperial-stitch-watches-plp-v26.js ===== */
/* WATCHES PLP V26 — deterministic facet order
   Required desktop order: Price → Watch House → Dial Colour → remaining filters. */
(()=>{
  const ROOT='.page-collection[data-template-suffix="luxury-watches"]';
  const DESKTOP=ROOT+' #FacetsWrapperDesktop';

  const norm=s=>String(s||'')
    .replace(/\(\d+\)/g,'')
    .replace(/\s+/g,' ')
    .trim()
    .toLowerCase();

  function labelOf(el){
    const summary=el.querySelector(':scope > summary');
    if(!summary) return '';
    const first=summary.querySelector('span');
    return norm(first ? first.textContent : summary.textContent);
  }

  function reorderDesktop(){
    const wrap=document.querySelector(DESKTOP);
    if(!wrap) return;

    const filters=[...wrap.querySelectorAll(':scope > details.js-filter')];
    if(filters.length<2) return;

    const watch=filters.find(el=>{
      const l=labelOf(el);
      return l==='watch house'||l==='brand'||l==='watch brand';
    });
    const dial=filters.find(el=>{
      const l=labelOf(el);
      return l==='dial colour'||l==='dial color'||l==='colour'||l==='color';
    });

    if(watch&&dial&&watch!==dial&&watch.nextElementSibling!==dial){
      wrap.insertBefore(watch,dial);
    }
  }

  function reorderMobile(){
    const root=document.querySelector(ROOT+' #FacetFiltersFormMobile');
    if(!root) return;
    const list=root.querySelector('.mobile-facets__main')||root;
    const items=[...list.querySelectorAll(':scope > details.mobile-facets__details, :scope > details.js-filter')];
    if(items.length<2) return;

    const text=el=>{
      const s=el.querySelector('summary');
      return norm(s?s.textContent:'');
    };
    const watch=items.find(el=>/watch house|brand|watch brand/.test(text(el)));
    const dial=items.find(el=>/dial colour|dial color/.test(text(el)));
    if(watch&&dial&&watch!==dial&&watch.nextElementSibling!==dial){
      list.insertBefore(watch,dial);
    }
  }

  function apply(){
    reorderDesktop();
    reorderMobile();
  }

  function init(){
    apply();
    requestAnimationFrame(apply);
    setTimeout(apply,120);
    setTimeout(apply,600);

    const filters=document.querySelector(ROOT+' #main-collection-filters')||
                  document.querySelector(ROOT+' #FacetFiltersForm');
    if(filters){
      new MutationObserver(()=>requestAnimationFrame(apply))
        .observe(filters,{childList:true,subtree:true});
    }
    document.addEventListener('shopify:section:load',apply);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

/* ===== assets/imperial-stitch-watches-plp-v29.js ===== */
/* WATCHES PLP V29 — whole-pound price control + formatted display */
(function(){
  'use strict';
  const ROOT='.page-collection[data-template-suffix="luxury-watches"]';

  function whole(value){
    const n=Number(String(value==null?'':value).replace(/,/g,''));
    return Number.isFinite(n) ? Math.max(0,Math.round(n)) : 0;
  }

  function gbpInteger(value){
    try{
      return whole(value).toLocaleString('en-GB',{maximumFractionDigits:0});
    }catch(e){
      return String(whole(value));
    }
  }

  function enhancePriceRange(scope){
    const root=scope&&scope.querySelectorAll ? scope : document;
    root.querySelectorAll('#main-collection-filters .it-filter-price price-range').forEach(function(priceRange){
      const numbers=Array.from(priceRange.querySelectorAll('.number-slider input'));
      const ranges=Array.from(priceRange.querySelectorAll('.range-slider input'));
      if(numbers.length<2 || ranges.length<2) return;

      ranges.forEach(function(input,index){
        input.step='1';
        if(input.value!=='') input.value=String(whole(input.value));

        if(input.dataset.itWholePoundReady!=='1'){
          input.dataset.itWholePoundReady='1';

          input.addEventListener('input',function(){
            input.value=String(whole(input.value));
            if(numbers[index]){
              numbers[index].value=input.value;
              syncVisual(numbers[index]);
            }
          });

          input.addEventListener('change',function(){
            input.value=String(whole(input.value));
            if(numbers[index]){
              numbers[index].value=input.value;
              syncVisual(numbers[index]);
            }
          });
        }
      });

      numbers.forEach(function(input,index){
        input.step='1';
        if(input.value!=='') input.value=String(whole(input.value));

        const field=input.closest('.field');
        if(!field) return;

        let visual=field.querySelector('.it-price-visual-value');
        if(!visual){
          visual=document.createElement('span');
          visual.className='it-price-visual-value';
          visual.setAttribute('aria-hidden','true');
          field.appendChild(visual);
        }

        function sync(){
          {const next=gbpInteger(input.value);if(visual.textContent!==next)visual.textContent=next;}
        }

        if(input.dataset.itWholePoundReady!=='1'){
          input.dataset.itWholePoundReady='1';

          input.addEventListener('focus',function(){
            field.classList.add('is-editing');
            input.value=String(whole(input.value));
          });

          input.addEventListener('input',function(){
            const cleaned=String(input.value||'').replace(/[^0-9]/g,'');
            if(cleaned!==String(input.value||'')) input.value=cleaned;
            if(ranges[index] && cleaned!=='') ranges[index].value=String(whole(cleaned));
            sync();
          });

          input.addEventListener('change',function(){
            input.value=String(whole(input.value));
            if(ranges[index]) ranges[index].value=input.value;
            sync();
          });

          input.addEventListener('blur',function(){
            input.value=String(whole(input.value));
            if(ranges[index]) ranges[index].value=input.value;
            field.classList.remove('is-editing');
            sync();
          });
        }

        sync();
      });

      function syncVisual(input){
        const field=input&&input.closest('.field');
        const visual=field&&field.querySelector('.it-price-visual-value');
        if(visual) {const next=gbpInteger(input.value);if(visual.textContent!==next)visual.textContent=next;}
      }
    });
  }

  function run(){
    if(!document.body || !document.body.matches(ROOT)) return;
    enhancePriceRange(document);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();

  document.addEventListener('shopify:section:load',function(){setTimeout(run,30);});

  let timer;
  const observer=new MutationObserver(function(mutations){
    if(!document.body || !document.body.matches(ROOT)) return;
    const relevant=mutations.some(function(m){
      return Array.from(m.addedNodes||[]).some(function(n){
        return n.nodeType===1 && (
          n.matches?.('#main-collection-filters, .it-filter-price, price-range') ||
          n.querySelector?.('#main-collection-filters .it-filter-price price-range')
        );
      });
    });
    if(relevant){
      clearTimeout(timer);
      timer=setTimeout(run,40);
    }
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();

/* ===== assets/imperial-stitch-watches-plp-v30.js ===== */
/* WATCHES PLP V30 — CONCISE BUY / SELL COPY */
(function(){
  'use strict';
  const ROOT='.page-collection[data-template-suffix="luxury-watches"]';

  function inScope(){
    return !!(document.body && document.body.matches(ROOT));
  }

  function setText(el,text){
    if(el && el.textContent!==text) el.textContent=text;
  }

  function refineIntro(){
    const assurance=document.querySelector('.it-watch-intro-assurance');
    if(!assurance) return;
    const labels=assurance.querySelectorAll('.it-watch-intro-assurance__item>span:last-child');
    if(labels[0]) setText(labels[0],'Private viewing · Kensington');
    if(labels[1]) setText(labels[1],'Buy online · Insured delivery');
  }

  function refineTrade(){
    const card=document.querySelector('.it-stitch-trade-card');
    if(!card) return;
    setText(card.querySelector('.it-stitch-trade-card__eyebrow'),'SELL · PART-EXCHANGE');
    setText(card.querySelector('h3'),'Sell or Part-Exchange Your Watch');
    setText(card.querySelector('p'),'Get a valuation from our Kensington watch team. Sell outright or part-exchange toward another timepiece.');
    setText(card.querySelector('a'),'Get a valuation →');
  }

  function refineSourcing(){
    const card=document.querySelector('.it-stitch-sourcing');
    if(!card) return;
    if(card.dataset.itV30==='1') return;
    card.dataset.itV30='1';
    card.innerHTML=
      '<span class="it-stitch-sourcing__eyebrow">FIND A WATCH</span>'+
      '<strong class="it-stitch-sourcing__title">Looking for a specific watch?</strong>'+
      '<p>Tell our Kensington specialists the brand, model or reference. We’ll help you find suitable stock.</p>'+
      '<a href="/pages/contact">Source a watch →</a>';
  }

  function refineProductFacts(scope){
    (scope||document).querySelectorAll('#product-grid .card').forEach(function(card){
      const status=card.querySelector('.it-watch-card-stock');
      const trust=card.querySelector('.it-watch-card-trust-text');
      if(!trust) return;

      const current=(trust.textContent||'').replace(/\s+/g,' ').trim();
      const stock=(status && status.textContent || '').replace(/\s+/g,' ').trim().toUpperCase();

      if(stock==='SOLD OUT'){
        setText(trust,'Ask our team to source another');
        return;
      }

      if(/^Insured tracked delivery/i.test(current)){
        setText(trust,current.replace(/^Insured tracked delivery/i,'Insured delivery'));
      }else if(/^Pre-owned · Specialist sourcing/i.test(current)){
        setText(trust,'Pre-owned · Ask us to source');
      }
    });
  }

  function run(){
    if(!inScope()) return;
    refineIntro();
    refineTrade();
    refineSourcing();
    refineProductFacts(document);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',run,{once:true});
  }else{
    run();
  }

  document.addEventListener('shopify:section:load',function(){setTimeout(run,40);});

  let timer;
  const observer=new MutationObserver(function(mutations){
    if(!inScope()) return;
    const relevant=mutations.some(function(m){
      return Array.from(m.addedNodes||[]).some(function(n){
        return n.nodeType===1 && (
          n.matches?.('#product-grid,.it-stitch-trade-card,.it-stitch-sourcing,.it-watch-intro-assurance') ||
          n.querySelector?.('#product-grid,.it-stitch-trade-card,.it-stitch-sourcing,.it-watch-intro-assurance')
        );
      });
    });
    if(relevant){
      clearTimeout(timer);
      timer=setTimeout(run,45);
    }
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();

/* ===== assets/imperial-stitch-watches-plp-v32.js ===== */
/* WATCHES PLP V32 — resilient price field enhancement */
(function(){
  'use strict';

  const ROOT='.page-collection[data-template-suffix="luxury-watches"]';

  function whole(value){
    const n=Number(String(value==null?'':value).replace(/[^0-9.-]/g,''));
    return Number.isFinite(n) ? Math.max(0,Math.round(n)) : 0;
  }

  function formatted(value){
    try{
      return whole(value).toLocaleString('en-GB',{maximumFractionDigits:0});
    }catch(e){
      return String(whole(value));
    }
  }

  function classifyPrice(details){
    if(!details) return;
    const summary=(details.querySelector('summary')?.textContent||'').toLowerCase();
    if(summary.includes('price') && !details.classList.contains('it-filter-price')) details.classList.add('it-filter-price');
  }

  function enhance(scope){
    if(!document.body || !document.body.matches(ROOT)) return;
    const root=scope&&scope.querySelectorAll ? scope : document;

    root.querySelectorAll('#main-collection-filters price-range').forEach(function(priceRange){
      const details=priceRange.closest('.facets__disclosure-vertical, details');
      classifyPrice(details);
      if(details && !details.classList.contains('it-filter-price')) return;

      const numbers=Array.from(priceRange.querySelectorAll('.number-slider input'));
      const ranges=Array.from(priceRange.querySelectorAll('.range-slider input'));
      if(numbers.length<2) return;

      numbers.forEach(function(input,index){
        input.step='1';

        const field=input.closest('.field');
        if(!field) return;

        let visual=field.querySelector('.it-price-visual-value');
        if(!visual){
          visual=document.createElement('span');
          visual.className='it-price-visual-value';
          visual.setAttribute('aria-hidden','true');
          field.appendChild(visual);
        }

        if(!field.classList.contains('it-price-enhanced')) field.classList.add('it-price-enhanced');

        function syncVisual(){
          {const next=formatted(input.value);if(visual.textContent!==next)visual.textContent=next;}
        }

        function syncRange(){
          if(ranges[index] && input.value!==''){
            ranges[index].step='1';
            ranges[index].value=String(whole(input.value));
          }
        }

        if(input.value!=='') input.value=String(whole(input.value));
        syncVisual();

        if(input.dataset.itPriceV32==='1') return;
        input.dataset.itPriceV32='1';

        input.addEventListener('focus',function(){
          field.classList.add('is-editing');
          input.value=String(whole(input.value));
          requestAnimationFrame(function(){
            try{ input.select(); }catch(e){}
          });
        });

        input.addEventListener('input',function(){
          const cleaned=String(input.value||'').replace(/[^0-9]/g,'');
          if(String(input.value||'')!==cleaned) input.value=cleaned;
          syncRange();
          syncVisual();
        });

        input.addEventListener('change',function(){
          input.value=String(whole(input.value));
          syncRange();
          syncVisual();
        });

        input.addEventListener('blur',function(){
          input.value=String(whole(input.value));
          syncRange();
          syncVisual();
          field.classList.remove('is-editing');
        });
      });

      ranges.forEach(function(range,index){
        range.step='1';
        if(range.value!=='') range.value=String(whole(range.value));

        if(range.dataset.itPriceV32==='1') return;
        range.dataset.itPriceV32='1';

        function fromRange(){
          range.value=String(whole(range.value));
          const input=numbers[index];
          if(!input) return;
          input.value=range.value;
          const visual=input.closest('.field')?.querySelector('.it-price-visual-value');
          if(visual) {const next=formatted(input.value);if(visual.textContent!==next)visual.textContent=next;}
        }

        range.addEventListener('input',fromRange);
        range.addEventListener('change',fromRange);
      });
    });
  }

  function run(){
    enhance(document);
    setTimeout(function(){enhance(document);},80);
    setTimeout(function(){enhance(document);},260);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',run,{once:true});
  }else{
    run();
  }

  document.addEventListener('shopify:section:load',run);

  let timer;
  const observer=new MutationObserver(function(mutations){
    if(!document.body || !document.body.matches(ROOT)) return;
    const relevant=mutations.some(function(m){
      if(m.type==='attributes') {const t=m.target;return Boolean(t && (t.id==='main-collection-filters' || (t.closest && t.closest('#main-collection-filters'))));}
      return Array.from(m.addedNodes||[]).some(function(n){
        return n.nodeType===1 && (
          n.matches?.('#main-collection-filters, price-range, .facets__disclosure-vertical') ||
          n.querySelector?.('#main-collection-filters price-range')
        );
      });
    });
    if(relevant){
      clearTimeout(timer);
      timer=setTimeout(run,30);
    }
  });

  observer.observe(document.documentElement,{
    childList:true,
    subtree:true,
    attributes:true,
    attributeFilter:['class']
  });
})();

/* ===== assets/imperial-stitch-watches-plp-v34.js ===== */
/* WATCHES PLP V34 — AVAILABILITY DESTINATIONS
   No forced client redirect. Shopify's native availability facet remains
   available for explicit Available / Sold-out catalogue views. */
(function(){
  'use strict';
  const ROOT='.page-collection[data-template-suffix="luxury-watches"]';

  function inScope(){
    return !!(document.body && document.body.matches(ROOT));
  }

  function state(){
    const u=new URL(location.href);
    return {
      url:u,
      availability:u.searchParams.get('filter.v.availability')
    };
  }

  function urlForAvailability(value){
    const u=new URL(location.href);
    u.searchParams.delete('page');
    u.searchParams.set('filter.v.availability',value);
    return u.pathname+'?'+u.searchParams.toString()+u.hash;
  }

  function availabilityCount(value){
    let count=0;
    document.querySelectorAll('#main-collection-filters input[type="checkbox"], #main-collection-filters input[type="radio"]').forEach(function(input){
      if(String(input.value)!==String(value)) return;
      const row=input.closest('label, li, .facets__item');
      const t=(row?.textContent||'').replace(/\s+/g,' ');
      const m=t.match(/\((\d+)\)/);
      if(m) count=Math.max(count,Number(m[1])||0);
    });
    return count;
  }

  function addSoldOutDestination(){
    const s=state();
    const wrappers=document.querySelectorAll('#ProductGridContainer .pagination-wrapper');
    wrappers.forEach(function(wrapper){
      const list=wrapper.querySelector('.pagination__list');
      if(!list || list.querySelector('.it-soldout-page-link')) return;

      if(s.availability==='1'){
        const outCount=availabilityCount('0');
        const li=document.createElement('li');
        const a=document.createElement('a');
        a.className='button pagination__item link it-soldout-page-link';
        a.href=urlForAvailability('0');
        a.setAttribute('aria-label','View sold out watches');
        a.innerHTML='Sold out'+(outCount>0?' <span>('+outCount+')</span>':'');
        li.appendChild(a);

        const nextArrow=list.querySelector('a.pagination__item-arrow[aria-label]');
        const nextLi=nextArrow?.closest('li');
        if(nextLi) list.insertBefore(li,nextLi);
        else list.appendChild(li);
      }

      if(s.availability==='0'){
        wrapper.classList.add('it-soldout-pagination');
        const back=document.createElement('a');
        back.className='it-soldout-back';
        back.href=urlForAvailability('1');
        back.textContent='← Available watches';

        const label=document.createElement('span');
        label.className='it-soldout-current';
        label.textContent='Sold out';

        wrapper.insertBefore(back,wrapper.firstChild);
        wrapper.insertBefore(label,wrapper.querySelector('.pagination'));
      }
    });
  }

  function labelGrid(){
    const s=state();
    const grid=document.querySelector('#product-grid');
    if(!grid) return;
    grid.dataset.availabilityView=s.availability==='0'?'sold-out':(s.availability==='1'?'available':'all');
  }

  function run(){
    if(!inScope()) return;
    labelGrid();
    addSoldOutDestination();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',run,{once:true});
  }else{
    run();
  }

  document.addEventListener('shopify:section:load',function(){setTimeout(run,40);});

  let timer;
  const observer=new MutationObserver(function(records){
    if(!inScope()) return;
    const relevant=records.some(function(r){
      return r.target&&r.target.closest&&(
        r.target.closest('#ProductGridContainer') ||
        r.target.closest('#main-collection-filters')
      );
    });
    if(relevant){
      clearTimeout(timer);
      timer=setTimeout(run,60);
    }
  });
  observer.observe(document.documentElement,{subtree:true,childList:true});
})();

/* ===== CLEAN MAIN WATCH CARD INTERACTIONS ===== */
(function(){
  'use strict';
  var KEY='imperial_time_watch_wishlist_v1';
  function inScope(){return location.pathname.indexOf('/collections/watches')===0;}
  function saved(){try{var x=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(x)?x:[];}catch(_){return [];}}
  function store(x){try{localStorage.setItem(KEY,JSON.stringify(x));}catch(_){}}
  function hrefFor(card){return card.querySelector('.card__heading a[href],.card__media a[href]')?.getAttribute('href')||'#';}
  function soldOut(card){var s=(card.querySelector('.it-watch-commerce-authority__stock')?.textContent||'').replace(/\s+/g,' ').trim().toUpperCase();return s==='SOLD OUT';}
  function updateHeart(btn,href){var on=saved().includes(href);btn.textContent=on?'♥':'♡';btn.setAttribute('aria-pressed',on?'true':'false');btn.setAttribute('aria-label',on?'Remove saved timepiece':'Save timepiece');}
  function cleanLegacy(card){
    card.querySelectorAll('.it-watch-mobile-pricebox,.it-watch-card-spec:not(.it-watch-card-spec--server),.it-watch-card-service:not(.it-watch-card-service--server),.it-watch-card-facts,.it-watch-legacy-stock,.it-watch-legacy-commerce-anchor,.card-information.card_price_bottom').forEach(function(el){el.remove();});
    card.querySelectorAll('.product__vendor').forEach(function(el){el.remove();});
    var boxes=card.querySelectorAll('.it-watch-commerce-authority');
    boxes.forEach(function(el,index){if(index>0)el.remove();});
    var box=card.querySelector('.it-watch-commerce-authority');
    if(box){
      box.querySelectorAll('.it-watch-commerce-authority__price').forEach(function(el,index){if(index>0)el.remove();});
      box.querySelectorAll('.it-watch-commerce-authority__current').forEach(function(el,index){if(index>0)el.remove();});
      box.querySelectorAll('.it-watch-commerce-authority__stock').forEach(function(el,index){if(index>0)el.remove();});
    }
  }
  function enhance(card){
    cleanLegacy(card);
    var href=hrefFor(card);
    var inner=card.querySelector('.card__inner');
    if(inner && !inner.querySelector('.it-watch-heart')){
      var heart=document.createElement('button');heart.type='button';heart.className='it-watch-heart';inner.appendChild(heart);
      heart.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var list=saved();list=list.includes(href)?list.filter(function(x){return x!==href;}):list.concat(href);store(list);updateHeart(heart,href);});
      updateHeart(heart,href);
    }
    var content=card.querySelector('.card__content');
    if(content){
      var cta=content.querySelector('.it-watch-card-cta');
      if(!cta){cta=document.createElement('a');cta.className='it-watch-card-cta';content.appendChild(cta);}
      cta.href=href;cta.classList.toggle('it-watch-card-cta--sold',soldOut(card));cta.textContent=soldOut(card)?'SOURCE ANOTHER':'INSPECT TIMEPIECE';
    }
  }
  function run(){if(!inScope())return;document.querySelectorAll('#product-grid .it-watch-card-context').forEach(enhance);}
  function queue(){clearTimeout(queue.t);queue.t=setTimeout(run,50);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
  document.addEventListener('shopify:section:load',function(){setTimeout(run,30);});
  new MutationObserver(function(records){if(!inScope())return;var relevant=records.some(function(r){var el=r.target&&(r.target.nodeType===1?r.target:r.target.parentElement);if(!el||!el.closest)return false;if(el.closest('.it-watch-heart,.it-watch-card-cta'))return false;return !!el.closest('#ProductGridContainer');});if(relevant)queue();}).observe(document.documentElement,{subtree:true,childList:true});
})();

/* ===== FINAL MOBILE WATCH CARD RUNTIME — 04 OCT 2026 ===== */
(function(){
  'use strict';

  function inScope(){
    return location.pathname.indexOf('/collections/watches')===0;
  }

  function imp(el,prop,value){
    if(el) el.style.setProperty(prop,value,'important');
  }

  function cleanText(v){
    return String(v||'').replace(/\s+/g,' ').trim();
  }

  function forceTitle(card){
    var a=card.querySelector('.card__heading a[data-it-card-display-title], .card__heading a');
    if(!a) return;
    var shortTitle=cleanText(a.getAttribute('data-it-card-display-title')||'');
    if(shortTitle && cleanText(a.textContent)!==shortTitle){
      a.textContent=shortTitle;
    }
    var h=a.closest('.card__heading');
    [h,a].forEach(function(el){
      imp(el,'height','44px');
      imp(el,'min-height','44px');
      imp(el,'max-height','44px');
      imp(el,'overflow','hidden');
      imp(el,'margin','0');
      imp(el,'padding','0');
    });
    imp(a,'display','-webkit-box');
    imp(a,'-webkit-box-orient','vertical');
    imp(a,'-webkit-line-clamp','2');
    imp(a,'line-clamp','2');
    imp(a,'white-space','normal');
    imp(a,'word-break','normal');
    imp(a,'overflow-wrap','normal');
    imp(a,'font-size','18px');
    imp(a,'line-height','1.08');
    imp(a,'text-align','center');
  }

  function removeLegacyAvailability(card){
    card.querySelectorAll('.it-watch-mobile-pricebox,.it-watch-legacy-stock,.it-watch-card-facts,.it-watch-legacy-commerce-anchor').forEach(function(el){
      el.remove();
    });

    var info=card.querySelector('.card__information');
    if(!info) return;
    info.querySelectorAll('*').forEach(function(el){
      if(el.children.length) return;
      if(el.closest('.it-watch-commerce-authority')) return;
      if(el.closest('.card-information.card_price_bottom')) return;
      if(el.classList.contains('it-watch-card-stock')) return;
      var t=cleanText(el.textContent).toLowerCase();
      if(t==='in stock'||t==='available'||t==='available to order'){
        el.remove();
      }
    });
  }

  function forceCurrentCommerce(card){
    var box=card.querySelector('.it-watch-commerce-authority');
    if(!box) return false;

    imp(box,'position','relative');
    imp(box,'width','auto');
    imp(box,'min-width','0');
    imp(box,'height','auto');
    imp(box,'min-height','84px');
    imp(box,'margin','3px -12px 0');
    imp(box,'padding','9px 12px 8px');
    imp(box,'display','grid');
    imp(box,'grid-template-columns','minmax(0,1fr)');
    imp(box,'grid-template-rows','auto auto');
    imp(box,'align-content','center');
    imp(box,'align-items','center');
    imp(box,'justify-items','center');
    imp(box,'row-gap','6px');
    imp(box,'overflow','hidden');
    imp(box,'box-sizing','border-box');
    imp(box,'background','#f4f0e8');
    imp(box,'border-top','1px solid #e8e3d9');
    imp(box,'border-bottom','1px solid #e8e3d9');

    var price=box.querySelector('.it-watch-commerce-authority__price');
    imp(price,'position','static');
    imp(price,'inset','auto');
    imp(price,'width','100%');
    imp(price,'min-width','0');
    imp(price,'max-width','100%');
    imp(price,'margin','0');
    imp(price,'padding','0');
    imp(price,'display','flex');
    imp(price,'flex-direction','column');
    imp(price,'align-items','center');
    imp(price,'justify-content','center');
    imp(price,'gap','2px');
    imp(price,'overflow','visible');
    imp(price,'text-align','center');
    imp(price,'transform','none');

    var current=box.querySelector('.it-watch-commerce-authority__current');
    imp(current,'position','static');
    imp(current,'display','block');
    imp(current,'margin','0');
    imp(current,'padding','0');
    imp(current,'font-size','24px');
    imp(current,'line-height','1');
    imp(current,'font-weight','750');
    imp(current,'letter-spacing','-.025em');
    imp(current,'white-space','nowrap');
    imp(current,'transform','none');

    var compare=box.querySelector('.it-watch-commerce-authority__compare');
    if(compare){
      imp(compare,'position','static');
      imp(compare,'display','block');
      imp(compare,'margin','0');
      imp(compare,'padding','0');
      imp(compare,'font-size','10px');
      imp(compare,'line-height','1');
      imp(compare,'white-space','nowrap');
      imp(compare,'transform','none');
    }

    var stock=box.querySelector('.it-watch-commerce-authority__stock');
    imp(stock,'position','static');
    imp(stock,'inset','auto');
    imp(stock,'display','block');
    imp(stock,'width','100%');
    imp(stock,'min-width','0');
    imp(stock,'max-width','100%');
    imp(stock,'margin','0');
    imp(stock,'padding','0');
    imp(stock,'font-size','9px');
    imp(stock,'line-height','1.05');
    imp(stock,'font-weight','800');
    imp(stock,'letter-spacing','.10em');
    imp(stock,'text-align','center');
    imp(stock,'text-transform','uppercase');
    imp(stock,'white-space','nowrap');
    imp(stock,'transform','none');

    return true;
  }

  function forceFallbackCommerce(card){
    var box=card.querySelector('.card-information.card_price_bottom:not(.it-watch-legacy-commerce-anchor)');
    if(!box) return;
    imp(box,'position','relative');
    imp(box,'width','auto');
    imp(box,'min-width','0');
    imp(box,'height','auto');
    imp(box,'min-height','78px');
    imp(box,'margin','3px -12px 0');
    imp(box,'padding','9px 12px 8px');
    imp(box,'display','grid');
    imp(box,'grid-template-columns','minmax(0,1fr)');
    imp(box,'grid-template-rows','auto auto');
    imp(box,'align-content','center');
    imp(box,'row-gap','5px');
    imp(box,'overflow','hidden');
    imp(box,'box-sizing','border-box');
    imp(box,'background','#f4f0e8');

    var w=box.querySelector('.wbhprice');
    imp(w,'position','static');
    imp(w,'inset','auto');
    imp(w,'width','100%');
    imp(w,'min-width','0');
    imp(w,'margin','0');
    imp(w,'padding','0');
    imp(w,'text-align','center');
    imp(w,'transform','none');

    box.querySelectorAll('.price__container,.price__sale').forEach(function(el){
      imp(el,'display','flex');
      imp(el,'flex-direction','column');
      imp(el,'align-items','center');
      imp(el,'justify-content','center');
      imp(el,'gap','2px');
      imp(el,'flex-wrap','nowrap');
    });
    box.querySelectorAll('.price-item--sale,.price__regular .price-item--regular').forEach(function(el){
      imp(el,'margin','0');
      imp(el,'font-size','24px');
      imp(el,'line-height','1');
      imp(el,'font-weight','750');
      imp(el,'white-space','nowrap');
    });
    box.querySelectorAll('.price--on-sale .price-item--regular').forEach(function(el){
      imp(el,'font-size','10px');
      imp(el,'line-height','1');
      imp(el,'white-space','nowrap');
    });
    var stock=box.querySelector('.it-watch-card-stock');
    if(stock){
      imp(stock,'position','static');
      imp(stock,'width','100%');
      imp(stock,'margin','0');
      imp(stock,'padding','0');
      imp(stock,'font-size','9px');
      imp(stock,'line-height','1.05');
      imp(stock,'font-weight','800');
      imp(stock,'letter-spacing','.10em');
      imp(stock,'text-align','center');
      imp(stock,'text-transform','uppercase');
      imp(stock,'white-space','nowrap');
    }
  }

  function stabiliseCard(card){
    if(!card) return;
    removeLegacyAvailability(card);
    forceTitle(card);

    var info=card.querySelector('.card__information');
    if(info){
      imp(info,'height','auto');
      imp(info,'max-height','none');
      imp(info,'overflow','visible');
    }

    var spec=card.querySelector('.it-watch-card-spec--server');
    if(spec){
      imp(spec,'height','40px');
      imp(spec,'min-height','40px');
      imp(spec,'max-height','40px');
      imp(spec,'overflow','hidden');
      imp(spec,'font-size','10.5px');
      imp(spec,'line-height','1.15');
      imp(spec,'text-align','center');
    }

    if(!forceCurrentCommerce(card)) forceFallbackCommerce(card);

    var service=card.querySelector('.it-watch-card-service--server');
    if(service){
      imp(service,'height','36px');
      imp(service,'min-height','36px');
      imp(service,'max-height','36px');
      imp(service,'overflow','hidden');
    }
  }

  function run(){
    if(!inScope() || !window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('#product-grid .it-watch-card-context').forEach(stabiliseCard);
  }

  function queue(){
    clearTimeout(queue.t);
    queue.t=setTimeout(run,20);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){
      run();
      setTimeout(run,80);
      setTimeout(run,300);
      setTimeout(run,900);
    },{once:true});
  }else{
    run();
    setTimeout(run,80);
    setTimeout(run,300);
    setTimeout(run,900);
  }

  window.addEventListener('load',function(){setTimeout(run,20);},{once:true});
  window.addEventListener('pageshow',function(){setTimeout(run,20);});
  window.addEventListener('resize',queue);
  document.addEventListener('shopify:section:load',function(){setTimeout(run,20);});

  new MutationObserver(function(records){
    if(!inScope()) return;
    var relevant=records.some(function(r){
      var el=r.target&&(r.target.nodeType===1?r.target:r.target.parentElement);
      return el&&el.closest&&el.closest('#ProductGridContainer');
    });
    if(relevant) queue();
  }).observe(document.documentElement,{subtree:true,childList:true,characterData:true});
})();
